'use strict';
invoiceAgingController.$inject = ['$scope', '$rootScope', '$q', '$interval', 'reportHelper', 'siteService', 'customerService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('invoiceAgingController', invoiceAgingController);

function invoiceAgingController($scope, $rootScope, $q, $interval, reportHelper, siteService, customerService, BUSY_MESSAGE) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.busyPromise = $q.all([$scope.vm.loadSites($scope.vm), $scope.vm.loadCustomers($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			busyMessage: BUSY_MESSAGE.Loading,

			report: {
				asOfDT: moment().toDate(),
				site: { Id: 0 },
				customerId: 0,
			},
			selectedCustomer: null,
			sites: [],
			backupSites: [],
			customers: [],
			backupCustomers: [],
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.report.asOfDT) {
				model.report.asOfDT = moment().toDate();
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				AsOfDT: model.report.asOfDT,
				CustomerId: model.report.customerId,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
			};

			reportHelper.getReport($scope, '/api/fundreports/invoiceagingreport', report, 'InvoiceAgingReport.pdf');
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				model.backupSites = angular.copy(model.sites);
				model.sites.unshift({ Id: 0, SiteName: 'All' });
				return angular.noop;
			}
		}

		function updateSiteList(model) {
			if (model.report.customerId !== 0) {
				// if Customer is not All then only show Sites that the Customer has access to
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = siteService.getSitesForCustomer(model.report.customerId).then(_.partial(finishGetSitesForCustomer, model));
			} else {
				model.sites = angular.copy(model.backupSites);
				model.sites.unshift({ Id: 0, SiteName: 'All' });
			}

			function finishGetSitesForCustomer(model, response) {
				model.sites = response.data.sites;
				model.sites.unshift({ Id: 0, SiteName: 'All' });
				let found = _.find(model.sites, function (obj) {
					return obj.Id === model.report.site.Id;
				});
				if (found === undefined) model.report.site.Id = 0;
				return angular.noop;
			}
		}

		function loadCustomers(model) {
			return customerService.getCustomers().then(_.partial(finishLoadingCustomers, model));

			function finishLoadingCustomers(model, response) {
				model.customers = response.data.customers;
				model.backupCustomers = angular.copy(model.customers);
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
				return angular.noop;
			}
		}

		function updateCustomerList(model) {
			if (model.report.site.Id !== 0) {
				// if Site is not All then only show Customers that have access to this Site
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = customerService.getCustomers(model.report.site.Id).then(_.partial(finishSearchingCustomers, model));
			} else {
				model.customers = angular.copy(model.backupCustomers);
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
			}

			function finishSearchingCustomers(model, response) {
				model.customers = response.data.customers;
				//model.customers = _.where(model.customers, { Active: "Active" });
				model.customers.unshift({ Id: 0, CustomerName: 'All' });
				let found = _.find(model.customers, function (obj) {
					return obj.Id === model.report.customerId;
				});
				if (found === undefined) model.report.customerId = 0;
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadSites: _.partial(loadSites, model),
			updateSiteList: _.partial(updateSiteList, model),
			loadCustomers: _.partial(loadCustomers, model),
			updateCustomerList: _.partial(updateCustomerList, model),
			openReport: _.partial(openReport, model),
		});
	}
}
